import { getCurrentUserEmail } from '../auth';
import { getEightDInfoId } from '../eightDInfoStore';

const toIsoOrNull = (date) => {
  if (!date) return null;
  try {
    const d = date instanceof Date ? date : new Date(date);
    return isNaN(d.getTime()) ? null : d.toISOString();
  } catch {
    return null;
  }
};

export const buildD8Payload = ({
  eightDInfoId,
  appreciationInput = '',
  responsiblePerson = '',
  plannedDate = null,
  achievedDate = null,
  uploadedFiles = [],
  isDisabled = false,
  attachmentsToRemove = [],
  currentUserEmail = getCurrentUserEmail(),
  d8Id = null,
  toList = [],
  ccList = [],
  isMailSent = false,
  reportNo = '',
  problemStatement = '',
}) => {
  const nowIso = new Date().toISOString();
  const finalEightDInfoId = eightDInfoId || getEightDInfoId();

  const Attachments = (uploadedFiles || [])
    .filter(f => !f.isExisting && f.preview)
    .map((f) => {
      const base64Data = f.preview;
      const attachmentData = base64Data.startsWith('data:') ? base64Data : `data:${f.file?.type || 'image/jpeg'};base64,${base64Data}`;
      return {
        EightDInfoId: finalEightDInfoId,
        AttachmentName: f.file?.name || f.localPath || '',
        AttachmentType: f.file?.type || '',
        AttachmentData: attachmentData,
        CreatedBy: currentUserEmail,
        CreatedOn: nowIso,
      };
    });

  return {
    ...(d8Id ? { D8Id: d8Id } : {}),
    EightDInfoId: finalEightDInfoId,
    AppreciationComment: appreciationInput || '',
    ResponsiblePerson: responsiblePerson || '',
    PlannedDate: toIsoOrNull(plannedDate),
    AchievedDate: toIsoOrNull(achievedDate),
    CcList: ccList.length > 0 ? ccList.join(', ') : '',
    toList: toList.map(t => ({ D1Id: t.D1Id || t.d1Id || 0, EmailId: t.EmailId || t.emailId || '' })),
    ccList,
    IsMailSent: isMailSent,
    ReportNo: reportNo,
    ProblemStatement: problemStatement,
    CreatedBy: currentUserEmail,
    CreatedOn: nowIso,
    ModifiedBy: currentUserEmail,
    ModifiedOn: nowIso,
    IsDisabled: isDisabled,
    Attachments,
    AttachmentsToRemove: attachmentsToRemove || [],
  };
};
